import React, { useEffect, useRef, useState } from "react";
import {
  AccordionContent,
  AccordionItem,
} from "../../components-shadcn/accordion";

import CustomAccordionTrigger from "../../../src/components/CustomAccordionTrigger";
import Product from "./Product";
import PaymentBoletoCheckout from "./PaymentBoletoCheckout";
import { useStore } from "../../lib/store";
import { isMobile } from "react-device-detect";
import PaymentCreditCardCheckout from "./PaymentCreditCardCheckout";
import PaymentPixAreaCheckout from "./PaymentPixCheckout";
import { AmplitudeLog } from "../../lib/amplitude";

interface Props {
  openItem: string;
}
const Payments: React.FC<Props> = ({ openItem }) => {

  const produtos = useStore((state) => state.produtos);
  const [open_products, set_open_products] = useState<string[]>([]);
  const default_open_applied = useRef<Set<string>>(new Set());

  const keys: any = {
    assinatura: "Assinatura",
    dinamometro_tracao: "Dinamômetro de tração",
    dinamometro_palmar: "Dinamômetro palmar"
  }

  type TypeFormasPagamento = Array<"cartao" | "pix" | "boleto">;

  const _renderMethodsPayment = (
    formas_pagamento: TypeFormasPagamento,
    produto: any,
    produto_type: "dinamometro_tracao" | "dinamometro_palmar" | "assinatura",
    entrada: boolean
  ) => {
    return (
      <div className={`flex w-[100%] flex-col gap-[0.7rem] mt-[1rem]`}>
        {formas_pagamento.includes("cartao") && (
          <PaymentCreditCardCheckout
            formas={"cartao"}
            produto_type={produto_type}
            produto={produto}
            entrada={entrada}
            wide
          />
        )}

        {formas_pagamento.includes("pix") && (
          <PaymentPixAreaCheckout
            formas={"pix"}
            produto_type={produto_type}
            produto={produto}
            entrada={entrada}
            wide />
        )}

        {formas_pagamento.includes("boleto") && (
          <PaymentBoletoCheckout
            formas={"boleto"}
            produto_type={produto_type}
            produto={produto}
            entrada={entrada}
            wide />
        )}
      </div>
    );
  };

  const _renderParcelamentoDoisCartoes = (
    produto: any,
    key: any,
    numero: number,
    fatura: "primeira_fatura_cc" | "segunda_fatura_cc"
  ) => {
    const valor_fatura_cc =
      fatura === "primeira_fatura_cc"
        ? produto.valor_primeira_fatura_cc
        : produto.valor_segunda_fatura_cc;
    const status_fatura =
      fatura === "primeira_fatura_cc"
        ? produto.status_primeira_fatura_cc
        : produto.status_segunda_fatura_cc;
    const rotulo = fatura === "primeira_fatura_cc" ? "Parcelamento 1" : "Parcelamento 2";
    const paga = Boolean(status_fatura?.pago || status_fatura?.autorizado);
    const rotuloStatus = status_fatura?.pago
      ? "Pago"
      : status_fatura?.autorizado
        ? "Autorizado"
        : null;

    return (
      <React.Fragment key={fatura}>
        <p className="text-green-dark text-[0.9rem] font-[600] mt-[1rem]">
          {numero}. {rotulo} do {keys[key]} {rotuloStatus && <span>- {rotuloStatus} ✅</span>}
        </p>
        {!paga && (
          <>
            <p className="mt-[0.6rem]">
              Selecione um meio de pagamento para pagar o {rotulo.toLowerCase()} do(a) {keys[key]}.
            </p>
            <div className={`flex w-[100%] flex-col gap-[0.7rem] mt-[1rem]`}>
              <PaymentCreditCardCheckout
                formas={"cartao"}
                produto_type={key}
                produto={produto}
                entrada={false}
                fatura_dois_cartoes={fatura}
                valor_fatura_cc={valor_fatura_cc}
                wide
              />
            </div>
          </>
        )}
      </React.Fragment>
    );
  };

  const _renderSectionPayments = (produto: any, key: any) => {
    return (
      <>
        <div
          onClick={() =>
            set_open_products((prev) =>
              prev.includes(key)
                ? prev.filter((item) => item !== key)
                : [...prev, key]
            )
          }
        >
          <Product
            title={produto.plano ? produto.plano : keys[key]}
            theme={open_products.includes(key) ? "green" : "gray"}
            imagem={key}
            pago={verifyPagoProduct(produto)}
            autorizado={verifyPaymentProduct(produto)}
          />
        </div>
        {open_products.includes(key) && !verifyPaymentProduct(produto) && (
          <>
            {produto.entrada && produto.entrada !== "0.00" && (
              <>
                <p className="text-green-dark text-[0.9rem] font-[600] mt-[1rem]">
                  1. Entrada do {keys[key]} {produto.status_entrada.pago && <span>- Pago ✅</span>}
                </p>
                {!produto.status_entrada.pago &&
                  <p className="mt-[0.6rem]">
                    Selecione um meio de pagamento para quitar a entrada do(a)
                    {keys[key]}.
                  </p>
                }
                {!produto.status_entrada.pago && _renderMethodsPayment(
                  produto.forma_pagamento_entrada,
                  produto,
                  key,
                  true,
                )}
              </>
            )}
            {produto.dois_cartoes ? (
              <>
                {_renderParcelamentoDoisCartoes(
                  produto,
                  key,
                  produto?.entrada !== "0.00" ? 2 : 1,
                  "primeira_fatura_cc"
                )}
                {_renderParcelamentoDoisCartoes(
                  produto,
                  key,
                  produto?.entrada !== "0.00" ? 3 : 2,
                  "segunda_fatura_cc"
                )}
              </>
            ) : (
              <>
                <p className="text-green-dark text-[0.9rem] font-[600] mt-[1rem]">
                  {produto?.entrada !== "0.00" ? "2. " : "1. "} {keys[key] !== "Assinatura" && "Parcelamento do "}  {keys[key]}.
                </p>
                <p className="mt-[0.6rem]">
                  Selecione um meio de pagamento para pagar a primeira fatura do(a) {keys[key]}.
                </p>
                {_renderMethodsPayment(
                  produto.formas_pagamento,
                  produto,
                  key,
                  false
                )}
              </>
            )}
            <hr className="mt-[1.5rem] mb-[1.5rem]" />
          </>
        )}
      </>
    );
  }

  const isQuitado = (status: any) => Boolean(status?.pago || status?.autorizado);
  const isPago = (status: any) => Boolean(status?.pago);

  // Quitado = tudo que se aplica a este produto está pago/autorizado:
  // status_produto sempre; status_entrada só quando há entrada; e, com
  // dois_cartoes=true, status_primeira_fatura_cc e status_segunda_fatura_cc
  // também (AC-068) — os 4 juntos, nunca um substituindo o outro.
  const verifyStatusProduct = (produto: any, check: (status: any) => boolean) => {
    const produtoOk = check(produto.status_produto);
    const entradaOk =
      produto.entrada && produto.entrada !== "0.00" ? check(produto.status_entrada) : true;
    const doisCartoesOk = produto.dois_cartoes
      ? check(produto.status_primeira_fatura_cc) && check(produto.status_segunda_fatura_cc)
      : true;
    return produtoOk && entradaOk && doisCartoesOk;
  }

  const verifyPaymentProduct = (produto: any) => verifyStatusProduct(produto, isQuitado);
  const verifyPagoProduct = (produto: any) => verifyStatusProduct(produto, isPago);

  // AC-072: cada produto define seu estado de aberto/fechado por padrão uma
  // única vez (quando aparece pela primeira vez em `produtos`) — aguardando
  // pagamento abre, pago/autorizado fica fechado. Depois disso, o toggle do
  // usuário manda.
  useEffect(() => {
    const novas_chaves = Object.keys(produtos || {}).filter(
      (key) => !default_open_applied.current.has(key)
    );
    if (novas_chaves.length === 0) return;

    novas_chaves.forEach((key) => default_open_applied.current.add(key));

    const chaves_aguardando_pagamento = novas_chaves.filter(
      (key) => !verifyPaymentProduct(produtos[key])
    );
    if (chaves_aguardando_pagamento.length > 0) {
      set_open_products((prev) => [...prev, ...chaves_aguardando_pagamento]);
    }
  }, [produtos]);

  return (
    <AccordionItem value="5">
      <CustomAccordionTrigger
        value="5"
        openItem={openItem}
        number={5}
        title="Pagamento"
      />
      <AccordionContent>
        <div className={`${!isMobile && 'flex flex-col gap-y-[1rem]'}`}>
          {
            Object.entries(produtos).reverse().map(([key, produto], index) => (
              _renderSectionPayments(produto, key)
            ))
          }
        </div>
      </AccordionContent>
    </AccordionItem>
  );
};

export default Payments;
